import { ReactNode, createContext } from 'react';

import {
  GraphPlaygroundPaneProps,
  PlaygroundPaneProps,
} from './components/debug/trace/GraphPlaygroundPane';
import { TraceLog } from './data/misc';

export const LangSmithAwareContext = createContext<{
  TraceLogRow?: (props: { traceLog: TraceLog }) => ReactNode;
  PlaygroundPaneAndTrigger?: (props: GraphPlaygroundPaneProps) => ReactNode;
  PlaygroundPane?: (props: PlaygroundPaneProps) => ReactNode;
  ExperimentModalAndButton?: () => ReactNode;
}>({});
